import { ApolloLink, HttpLink } from '@apollo/client';
import config from '@src/config/config';

export const publicEndpointLink: ApolloLink = new HttpLink({
  uri: config.graphqlPublicApi,
});
